import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Card,
  Divider,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { SearchField } from "../../components/SearchField";
import { IArticle } from "../../core/redux/dataMap/article";
import {
  Actions as ArticleActions,
  Creators,
} from "../../core/redux/ducks/article";
import { PathText } from "./style/styledComponents";
import { Loading } from "../../components/Loading";
import { Creators as LabelsCreaters } from "../../core/redux/ducks/label";

interface IContentClipperProps {}

export const ContentClipper: React.FC<IContentClipperProps> = () => {
  const classes = useStyles();
  const [searchArticleName, setSearchArticleName] = useState("");
  const [filteredArticles, setFilteredArticles] = useState([]);
  const { articles, loading } = useSelector((state) => state.article);
  const dispatch = useDispatch();
  const fetchArticles = () =>
    ArticleActions.fetchArticles(dispatch, "-updated_at", true);
  useEffect(() => {
    fetchArticles();
  }, []);

  useEffect(() => {
    setFilteredArticles(articles);
  }, [articles]);

  const searchArticle = (searchName) => {
    if (searchName === "") {
      setFilteredArticles(articles);
    } else {
      const filterArticles = articles.filter((article) => {
        return article.name.toLowerCase().includes(searchName.toLowerCase());
      });
      setFilteredArticles(filterArticles);
    }
    setSearchArticleName(searchName);
  };

  const setArticle = (article) => {
    dispatch(Creators.addArticleSuccess(article, ""));
    dispatch(LabelsCreaters.getLabelsSuccess(article.labels));
  };

  return (
    <Grid container direction="column" className={classes.root} spacing={1}>
      <Grid item className={classes.title}>
        <Typography variant="h5">Content clipper</Typography>
      </Grid>
      <Grid item>
        <Grid container alignItems="center">
          <Grid item md={12} className={classes.searchFieldContainer}>
            <SearchField
              label="Suchen"
              value={searchArticleName}
              onChange={searchArticle}
              onSubmit={searchArticle}
              color="gray"
            />
          </Grid>
        </Grid>
      </Grid>
      <div className={classes.articlesList}>
        {loading && !filteredArticles.length && <Loading />}
        {filteredArticles &&
          filteredArticles.map((article: IArticle, index) => (
            <div onClick={() => setArticle(article)} key={index}>
              <Grid item className={classes.cardContainer}>
                <Card className={classes.card}>
                  <Grid container direction="column" spacing={3}>
                    <Grid item>
                      <PathText>{article.path}</PathText>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="body2"
                        className={classes.articleName}
                      >
                        {article.name}
                      </Typography>
                    </Grid>
                    <Divider />
                    <Grid item>
                      <Grid container alignItems="center">
                        <Grid item md={12}>
                          <Typography
                            variant="body1"
                            className={classes.articleOwner}
                          >
                            {`${article.owner.firstName} ${
                              article.owner.lastName || ""
                            }`}
                          </Typography>
                        </Grid>
                        {/* <Grid item md={1}>
                        <IconButton
                          
                          className={classes.cardButton}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      </Grid> */}
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </div>
          ))}
      </div>
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "0 20px",
    },
    folderInitials: {
      width: "23px",
      height: "23px",
      background: "#9BCE63",
      borderRadius: "4px",
      color: "#fff",
      textAlign: "center",
    },
    articlesList: {
      overflowY: "auto",
      maxHeight: "calc(100vh - 237px)",
      padding: "0 15px",
    },
    addButton: {
      padding: "5px",
    },
    cardContainer: {
      margin: "15px 0",
      cursor: "pointer",
    },
    card: {
      boxShadow: "2px 2px 20px rgba(0, 0, 0, 0.15)",
      padding: "10px 10px 5px 10px",
    },
    articleName: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#323232",
    },
    articleOwner: {
      fontSize: "12px",
      lineHeight: "12px",
      color: "#5C5E62",
      paddingBottom: "5px",
    },
    searchFieldContainer: {
      padding: "0 10px",
    },
    cardButton: {
      padding: "5px",
    },
    title: {
      paddingLeft: "15px !important",
    },
  })
);
